module.exports = __webpack_public_path__ + "s/img/Glam_M_3.cc112cb3.jpg";